export enum WORK_ORDER_TEMPLATE {
  DEALER_ADVERTISING = "WorkOrderDealerAdvertising",
  EDM = "WorkOrderEdm",
  INSTORE_DIGITAL = "WorkOrderVisMerchDigital",
  INSTORE_PRINT = "WorkOrderVisMerchPrint",
  PAID_MEDIA = "WorkOrderPaidMedia",
  SIMPLE = "WorkOrderSimple",
  WEB = "WorkOrderWebBanner",
}
